import { Clip } from '../types';
import { SendableItem } from '@features/send/types';

export const mapClipToSendableItem = (clip: Clip): SendableItem => ({
    id: parseInt(clip.mediaObjectId, 10),
    name: clip.clipName,
});
